<template>
  <div>
    <modal :isFooter="false" v-if="isModalVisible" @close="closeModal">
      <template v-slot:body>
        <addMimk
          ref="modalBody"
          :isAppoint="isAppoint"
          :MasterClass="MasterClass"
          @closeModal="closeModal"
        />
      </template>
    </modal>
    <header-page
      ref="headerPage"
      :namePage="$t('pagesTitles.mc')"
      :isSearchInput="true"
      :links="$store.state.headerLinks.supervisorMcLinks"
      @clearSearchInput="clearSearchInput"
      @searchByAmoId="searchByAmoId"
    />
    <div class="content">
      <SearchPeriod @searchByDate="searchByDate" />
      <loader v-if="isLoad" />
      <template v-else>
        <div class="flex-center">
          <button
            class="btn btn_autowidth btn_blue btn_is-margin-left"
            @click="distributeMk"
            :disabled="disabledButton"
          >
            {{ $t("mc.supervisor.buttons.distributeMc") }}
          </button>
        </div>
        <TableCommon
          ref="mcTableCurrent"
          :emptyTableTitleName="emptyTitle"
          :sizeColumn="sizeColumn"
          :propsTableData="currentData"
          @callModal="callModal"
          :isCurrent="true"
          :zoomActive="true"
        />
        <TableCommon
          ref="mcTableFuture"
          :emptyTableTitleName="emptyTitle"
          :sizeColumn="sizeColumn"
          :propsTableData="nextData"
          @callModal="callModal"
          :isFuture="true"
          :zoomActive="true"
        />
      </template>
    </div>
  </div>
</template>

<script>
import TableCommon from "@/components/Supervisor/TableCommon";
import globalSettingCalendar from "@/helpers/globalSettingCalendar";
import SearchPeriod from "@/components/UI/DatePickerPeriod";
import apiBooking from "@/api/master-classes/booking";
import apiTags from "@/api/tags";
import addMimk from "@/components/Supervisor/AddMimk";
export default {
  data() {
    return {
      globalSettingCalendar,
      searchDateFrom: "",
      searchDateTo: "",
      isAppoint: true,
      disabledButton: false,
      MasterClass: null,
      isModalVisible: false,
      currentData: [],
      nextData: [],
      sizeColumn: "150px 16px 90px 1.5fr 2fr 160px 100px 100px",
      isLoad: true,
    };
  },
  components: {
    addMimk,
    TableCommon,
    SearchPeriod,
  },
  watch: {
    nextData() {
      if (this.nextData.length) {
        const bookingIds = this.nextData.map(booking => booking.id)
        const mimkIds = this.nextData.map(booking => booking.mimk)

        if (bookingIds.length) apiTags.getBookingsTags(bookingIds, true)
        if (mimkIds.length) apiTags.getMimksTags(mimkIds, this.$store.state.user.segment.id, true)
      }
    },
    currentData() {
      if (this.currentData.length) {
        const bookingIds = this.currentData.map(booking => booking.id)
        const mimkIds = this.currentData.map(booking => booking.mimk)

        if (bookingIds.length) apiTags.getBookingsTags(bookingIds, true)
        if (mimkIds.length) apiTags.getMimksTags(mimkIds, this.$store.state.user.segment.id, true)
      }
    },
  },
  methods: {
    async searchByAmoId(searchedString) {
      //Принимаем строку из инпута
      this.currentPage = 1;
      this.futurePage = 1;
      this.isLoad = true;
      //Отправляем запрос для поиска МК
      const searchedMasterClasses = await apiBooking.getMkByLink(
        searchedString
      );
      //Если ничего не найдено выходим из функции
      if (!searchedMasterClasses) {
        this.isLoad = false;
        return;
      }
      //Если МК найдены строим новые таблицы
      this.nextData = [...searchedMasterClasses.future];
      this.currentData = [...searchedMasterClasses.current];
      this.isLoad = false;
    },
    async searchByDate({ start, finish }) {
      this.loading = true;
      this.searchDateFrom = start;
      this.searchDateTo = finish;
      await this.getAllBookings(this.searchDateFrom, this.searchDateTo);
      this.loading = false;
    },

    async distributeMk() {
      this.disabledButton = true;
      await apiBooking.manualDistribute();
      this.disabledButton = false;
    },
    async getAllBookings(date, dateTo) {
      this.isLoad = true;
      //Получаем МК по принимаемой в аргументе дате и строим таблицы текущих и будущих МК
      const mkList = await apiBooking.getBookingsAll(
        this.$dayjs(date, "DD.MM.YYYY").format("YYYY-MM-DD") + " 00:00",
        this.$dayjs(dateTo, "DD.MM.YYYY").format("YYYY-MM-DD") + " 00:00"
      );
      this.currentData = [...mkList.current];

      this.nextData = [...mkList.future];
      console.log(this.nextData);
      this.isLoad = false;
    },
    callModal({ type, TC }) {
      //Принимаем в type изменение или назначения мимка и МК
      this.isModalVisible = true;
      this.MasterClass = TC;
      //isAppoint пропс для передачи в дочерний компонент с модалкой, для опредления отображения текста кнопки
      type === "changeMimk"
        ? (this.isAppoint = false)
        : (this.isAppoint = true);
    },
    async clearSearchInput() {
      await this.getAllBookings(this.searchDateFrom, this.searchDateTo);
    },
    async closeModal(isRerender) {
      //При закрытии модалки убираем активный класс с выбранного мимка
      this.$refs.modalBody.removeCheckMimk();
      this.isModalVisible = false;
      //Если закртие произошло после назначения МК, то делаем запрос на получения МК и перерендериваем страницу
      if (isRerender) {
        this.isLoad = true;
        await this.getAllBookings(this.searchDateFrom, this.searchDateTo);
        this.isLoad = false;
      }
    },
  },
  computed: {
    today() {
      return this.$dayjs(new Date()).format("D MMMM");
    },
    emptyTitle() {
      let title;
      if (!this.nextData.length && !this.currentData.length) title = "";
      else {
        if (!this.nextData.length) title = this.$t("mc.mimk.titleNext");
        if (!this.currentData.length) title = this.$t("mc.mimk.titleCurrent");
      }
      return title;
    },
  },
};
</script>

<style lang="scss" scoped>
.mk-current {
  justify-content: space-between;
  &__title {
    display: flex;
  }
}
.mk-future {
  margin-top: 40px;
}
.check-icon {
  margin-right: 8px;
}
</style>
